// ファイル添付のコンポーネント
/*-------------------
     モジュールのimport
 ---------------------*/
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import imageCompression from 'browser-image-compression';

/**
 *ファイル添付のコンポーネント
 *
 * @class AttachmentArea
 * @extends {PureComponent}
 */
class AttachmentArea extends React.Component {
  constructor(props) {
    super(props);

    const { commonState = '', compressValue = '', maxTotalSize = 0, maxAttach = 5 } = props;

    this.state = {
      commonState,
      compressValue,
      attachList: [],
      fileDataArray: [],
      maxTotalSize, // 添付できる上限サイズ(単位はMB)
      maxAttach,
      errMsg: '',
    };
  }

  componentDidMount = async () => {
    this.setState({ attachList: this.dispImage([]) });

    // 以下、ドロップエリア用
    // アップロードエリアの要素を取得。
    const uploadAreaElem = document.getElementById('upload-area') || '';
    if (uploadAreaElem === '') return;

    // 指定エリアにドロップされた場合の処理
    uploadAreaElem.addEventListener('drop', (e) => {
      uploadAreaElem.className = 'image-slot add-button';
      const { length = 0 } = e.dataTransfer.files;
      if (length === 0) return;
      this.getImage(e.dataTransfer.files);
    });

    let a = new Date().getTime();
    // 画面上のどこかにドラッグされると動く
    document.addEventListener('dragover', (e) => {
      uploadAreaElem.className = 'image-slot add-button-drop';
      e.preventDefault();
      a = new Date().getTime();
      setTimeout(() => {
        // 最終dragover発火時間から2秒経過している場合は元に戻す。
        if (new Date().getTime() - a > 1000) {
          uploadAreaElem.className = 'image-slot add-button';
        }
      }, 1 * 1000);
    });

    // 指定エリア外でドロップすると動く。
    document.addEventListener('drop', (e) => {
      e.preventDefault();
    });
  };

  /**
   * 画像の削除処理
   *
   * @memberof PostSend
   */
  onClickBtnDel = (num) => {
    const { fileDataArray, commonState } = this.state;
    fileDataArray.splice(num, 1);
    const attachList = this.dispImage(fileDataArray);
    this.setState({ fileDataArray, attachList });
    // document.getElementById('upload-form-fileselect').value = '';
    commonState({ fileDataArray });
  };

  /**
   * 画像添付する。
   *
   * @memberof PostResidentEdit
   */
  dispImage = (dataArray) => {
    const { maxAttach } = this.state;
    const attachList = [];
    for (let i = 0; i < dataArray.length; i += 1) {
      const { data } = dataArray[i];
      attachList.push(
        <div className="image-wrapper" key={`attach_${i}`}>
          <img src={`data:image/jpeg;base64,${data}`} alt="添付画像" />
          <button className="remove-button" type="button" onClick={() => this.onClickBtnDel(i)}>
            ×
          </button>
        </div>
      );
    }

    // 最大数に満たない場合は残りを表示
    for (let i = 0; i < maxAttach - dataArray.length - 1; i += 1) {
      attachList.push(<div key={`empty_${i}`} className="image-slot" />);
    }

    return attachList;
  };

  /**
   * ファイルをBase64形式に変換する
   * @param {File} file 変換するファイル
   * @returns {Promise<string>} Base64形式のデータURL
   */
  fileToBase64 = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result.split(',')[1];
        resolve({
          name: file.name,
          data: base64Data,
          date: file.lastModified,
          lastModified: file.lastModified,
          type: file.type,
          size: file.size,
        });
      };
      reader.onerror = () => {
        resolve(false);
      };
      reader.readAsDataURL(file);
    });

  /**
   * ファイルをJpeg形式に変換する
   * @param {File} file 変換するファイル
   * @returns {Promise<string>} Base64形式のデータURL
   */
  convertToJpeg = async (file) =>
    new Promise((resolve) => {
      const image = new Image();
      image.src = URL.createObjectURL(file);

      image.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Canvasに画像を描画
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        // JPEGに変換したBlobを取得
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const jpegFile = new File([blob], file.name.replace(/\.\w+$/, '.jpeg'), {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              resolve(jpegFile);
            } else {
              window.alert(`${file.name}のJPEG変換に失敗しました`);
              resolve(false);
            }
          },
          'image/jpeg',
          1
        ); // 変換後のJPEG画像の品質（0〜1）を指定
      };

      image.onerror = () => {
        window.alert(`${file.name}の読み込みに失敗しました`);
        resolve(false);
      };
    });

  /**
   * 画像を圧縮する
   * @param {File} file 圧縮前の画像ファイル
   * @returns {Promise<File>} 圧縮後の画像ファイル
   */
  compressImage = async (file) => {
    const { compressValue } = this.state;
    let imageFile = file;
    if (file.type !== 'image/jpeg') {
      imageFile = (await this.convertToJpeg(file)) || false;
    }
    if (imageFile === false) return false;

    const options = {
      maxSizeMB: compressValue, // 最大サイズを設定
      useWebWorker: true, // Web Workerを有効にする（デフォルトで有効）
      maxWidthOrHeight: 4096, // 最大解像度
      initialQuality: 1, // 圧縮品質
    };
    try {
      return await imageCompression(imageFile, options);
    } catch (error) {
      window.alert(`${file.name}の圧縮に失敗しました`);
      return false;
    }
  };

  /**
   * 画像ファイルを処理する
   * @param {File} file 画像ファイル
   * @returns {Promise<string>} 圧縮またはそのままのBase64形式の画像
   */
  processImage = async (file) => {
    const { compressValue: maxSizeMB = 1.5, commonState } = this.state;
    const fileSizeMB = file.size / (1024 * 1024); // ファイルサイズをMBに変換

    // 圧縮上限が0の場合は圧縮しない
    if (fileSizeMB > maxSizeMB && maxSizeMB > 0) {
      // 画像アップロード中メッセージを出す。
      commonState({ compressFlag: true });

      // 1MBを超える場合、画像を圧縮してBase64に変換
      const compressedFile = await this.compressImage(file);
      // saveAs(compressedFile, `${new Date().getTime()}.jpg`); // 好きなファイル名と拡張子を指定
      if (compressedFile === false) return false;
      return this.fileToBase64(compressedFile);
    }
    // 指定容量以下の場合、そのままBase64に変換
    return this.fileToBase64(file);
  };

  /**
   * 画像添付する。
   *
   * @memberof PostSend
   */
  getImage = async (imageFile) => {
    const { fileDataArray, maxTotalSize, maxAttach, commonState } = this.state;

    // 指定の拡張子以外のファイルがある場合はエラー
    const errList = [];
    for (let i = 0; i < imageFile.length; i += 1) {
      const { type = '', name } = imageFile[i];
      const format = type.split('/')[0];
      if (format !== 'image') errList.push(`添付ファイル(${name})が画像形式ではありません。`);
    }
    if (errList.length !== 0) {
      window.alert(errList.toString().replace(/,/g, '\n'));
      return;
    }

    // 添付済み+追加したファイル数が指定を超える場合エラー
    if (imageFile.length + fileDataArray.length > maxAttach) {
      this.setState({ errMsg: `添付ファイル数は${maxAttach}枚以下にしてください` });
      return;
    }

    // 最大枚数が設定されている場合のみチェックする。
    if (maxTotalSize > 0) {
      // 添付済み+追加したファイルの容量が指定を超える場合エラー
      let totalSizeMB = 0;
      for (let i = 0; i < imageFile.length; i += 1) {
        const { size } = imageFile[i];
        totalSizeMB += size / (1024 * 1024);
      }
      for (let i = 0; i < fileDataArray.length; i += 1) {
        const { size } = fileDataArray[i];
        totalSizeMB += size / (1024 * 1024);
      }

      if (totalSizeMB > maxTotalSize) {
        this.setState({ errMsg: `合計${maxAttach}MB 以下にしてください` });
        return;
      }
    }

    // 配列で持っているファイルデータをbase64に変換する。
    // Promise.allで並列処理
    const tmpDataArray = await Promise.all(
      Array.from(imageFile).map((file) => this.processImage(file))
    );

    // 添付済みのものと今回添付したものを合わせる。
    const newDataArray = [...fileDataArray];
    for (let i = 0; i < tmpDataArray.length; i += 1) {
      if (tmpDataArray[i] === false) continue;
      newDataArray.push(tmpDataArray[i]);
    }

    const attachList = this.dispImage(newDataArray);

    this.setState({ fileDataArray: newDataArray, attachList, errMsg: '' });
    commonState({ fileDataArray: newDataArray, compressFlag: false });
  };

  test = () => {
    //   const { fileDataArray } = this.state;
    //   console.log(fileDataArray);
    // console.log(document.getElementById('upload-form-fileselect').value);
  };

  render() {
    const { attachList = [], compressValue, maxAttach, errMsg } = this.state;

    return (
      <div>
        <div className="image-upload-container">
          <input
            id="upload-area"
            type="submit"
            className="image-slot add-button"
            value="+"
            style={{ display: attachList.length === maxAttach ? 'none' : '' }} // 表示しない
            // 以下は、input="file"を押下した際の処理を走らせる。
            onClick={() => document.getElementById('upload-form-fileselect').click()}
          />
          <input
            id="upload-form-fileselect"
            type="file"
            accept="image/*,.png,.jpg,.jpeg,.gif"
            onChange={(e) => this.getImage(e.target.files)}
            style={{ display: 'none' }} // 表示しない
            multiple
          />
          {attachList}
          <p className="note">※{compressValue}MBを超える画像は圧縮して送信されます。</p>
        </div>
        {errMsg === '' ? null : <div className="notice alertFault">{errMsg}</div>}
      </div>
    );
  }
}

AttachmentArea.propTypes = {
  commonState: PropTypes.func.isRequired,
  compressValue: PropTypes.number.isRequired,
  maxTotalSize: PropTypes.number.isRequired,
  maxAttach: PropTypes.number.isRequired,
};

export default withRouter(AttachmentArea);
